import { playSound, SoundName } from './play-sound';
import { AlertType } from './alert-type';

const alertSoundMap: Record<AlertType, SoundName> = {
    [AlertType.NEW_UNASSIGNED_EVENT]: 'new-event-alert',
    [AlertType.AED_ATTEMPTING_ACCEPTING]: 'aed-attempting-accepting',
};

function makeSoundKey(eventId: number, alertType: AlertType): string {
    return `${eventId}-${alertType}`;
}

export class SoundAlertStore {
    private soundPlayed: Record<string, true> = {};

    playSoundForEvent(eventId: number, alertType: AlertType): void {
        const key = makeSoundKey(eventId, alertType);
        if (this.soundPlayed[key]) return;
        this.soundPlayed[key] = true;
        playSound(alertSoundMap[alertType]);
    }

    removeSoundForEvent(eventId: number): void {
        for (const alertType of Object.values(AlertType)) {
            delete this.soundPlayed[makeSoundKey(eventId, alertType)];
        }
    }
}

export const soundAlertStore = new SoundAlertStore();
